import type { Element } from 'react'
import React, { Component } from 'react'
import styled from 'styled-components'
import { colors } from 'shared/assets/styles'

const { red6 } = colors

type Props = {
    title?: Element<any>,
    content?: Element<any>,
    disabled?: boolean,
    unavailable?: boolean
}

type State = {
    collapsed: boolean
}

export class Collapsible extends Component<Props, State> {
    state = {
        collapsed: false
    }

    onPress = () => this.setState({ collapsed: !this.state.collapsed })

    render() {
        const {
            title,
            content,
            disabled = false,
            unavailable = false
        } = this.props
        const { collapsed } = this.state

        return (
            <Container>
                <Header
                    disabled={disabled}
                    onClick={this.onPress}
                    collapsed={collapsed}
                    color={unavailable ? red6 : 'white'}>
                    {title}
                </Header>
                {collapsed && disabled === false && (
                    <CollapsibleElement>{content}</CollapsibleElement>
                )}
            </Container>
        )
    }
}

const Container = styled.div`
    background: white;
    border-radius: 8px;
`

const Header = styled.div`
    background: ${props => props.color};
    padding: 15px;
    ${props =>
        !props.collapsed
            ? 'border-radius: 10px;'
            : `border-top-left-radius: 10px;
    border-top-right-radius: 10px;`};
    cursor: ${props => (props.disabled ? 'default' : 'pointer')};
`

const CollapsibleElement = styled.div``
